import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { If } from 'src/Components'
import HasPrequalScreen from './HasPrequalScreen'
import NoPrequalScreen from './NoPrequalScreen'

import styles from './PrequalTab.module.scss'

const propTypes = {
  className: PropTypes.string
}

const PrequalTab = ({ className, hasPrequal }) => (
  <div className={classnames(styles.root, className)}>
    <If condition={hasPrequal}>
      <HasPrequalScreen />
    </If>
    <If condition={!hasPrequal}>
      <NoPrequalScreen />
    </If>
  </div>
)

PrequalTab.propTypes = propTypes

export default PrequalTab
